import React, { useMemo, useEffect } from "react";
import {
  APIProvider,
  Map,
  useMap,
  AdvancedMarker,
} from "@vis.gl/react-google-maps";
import { HeatmapLayer } from "@deck.gl/aggregation-layers";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
import { IconStar } from "@tabler/icons-react";
import { Text } from "@mantine/core";

import mapPin from "@assets/map-pin.svg";

function DeckGLOverlay(props) {
  const map = useMap();
  const overlay = useMemo(() => new GoogleMapsOverlay(), []);

  useEffect(() => {
    overlay.setMap(map);
    return () => overlay.setMap(null);
  }, [map]);

  overlay.setProps(props);
  return null;
}

export default function HeatMap({
  data = [],
  defaultCenter = {
    lat: 33.749937,
    lng: -84.390744,
  },
  defaultZoom = 11,
  pins = [],
}) {
  const layers = new HeatmapLayer({
    id: "HeatmapLayer",
    data: data.filter((f) => f.lat && f.lng),
    getPosition: (d) => [d.lng, d.lat],
    getWeight: (d) => d.weight,
    radiusPixels: 25,
  });

  if ((!data || !data.length) && (!pins || !pins.length))
    return (
      <Text fw={600} mb="md">
        No data available
      </Text>
    );

  const formattedPins = pins.filter((f) => f.lat && f.lng);

  return (
    <div style={{ height: "600px", width: "100%" }}>
      <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
        <Map
          defaultCenter={defaultCenter}
          defaultZoom={defaultZoom}
          mapId="default"
          zoomControl={false}
          streetViewControl={false}
        >
          {formattedPins.map((pin, i) => {
            if (pin.special) {
              return (
                <AdvancedMarker
                  position={{ lat: pin.lat, lng: pin.lng }}
                  key={i}
                >
                  <IconStar
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "50%",
                      height: "30px",
                      width: "30px",
                      transform: "translate(-50%, -100%)",
                      color: "var(--mantine-color-dark-5)",
                    }}
                    key={i}
                    fill="var(--mantine-color-yellow-5)"
                  />
                </AdvancedMarker>
              );
            }
            return (
              <AdvancedMarker position={{ lat: pin.lat, lng: pin.lng }} key={i}>
                <img
                  src={mapPin}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "50%",
                    height: "24px",
                    width: "24px",
                    transform: "translate(-50%, -100%)",
                  }}
                />
              </AdvancedMarker>
            );
          })}
          {data.length > 0 && <DeckGLOverlay layers={layers} />}
        </Map>
      </APIProvider>
    </div>
  );
}
